import { Navigate, useParams } from 'react-router-dom';

/* The full per-client view now lives INSIDE the Command Center as one big page
   (client switcher + operations + full account/profile + live preview). This old
   /admin/user/:uid route just redirects there with the client preselected, so
   there's a single canonical "everything" page. */

export default function AdminUserDetail() {
  const params = useParams();
  const uid = (params as { uid?: string }).uid;
  const base = '/admin/command-center';
  return <Navigate to={uid ? `${base}?client=${uid}` : base} replace />;
}
